import api from '@/api'
import http from '@/utils/request'
import { Toast } from 'vant'

export default {
  namespaced: true,
  state: {
    studnetData: [] // 学生信息
  },
  mutations: {
    setStudnetData(state, data) {
      state.studnetData = data
    }
  },
  actions: {
    async getStudnetData({ state, commit }) {
      try {
        const res = await http.json_post(api.my.studentInfo, {
          student_id: localStorage.getItem('studentId'),
          pageNo: 1,
          pageSize: 1
        })
        if (res.code !== 200) Toast('状态异常,请稍后~ \b/card/ioticcid/imei/page_imei')
        commit('setStudnetData', res)
      } catch {
        Toast('服务器出现异常,请稍后~ \b/card/ioticcid/imei/page_imei')
      }
    }
  }
}
